import React, { useState, useEffect } from 'react';
import Aux from '../../hoc/Aux';
import { axiosPublic } from '../../axios-wizard';
import { URLS } from '../../urls';

const Logobar = (props) => {

  const actionUrl = '/api/frontend_seal_list'
  const [logos, setLogos] = useState([]);

  const filterSeals = (logos) => logos.filter( x => x.display_frontpage === true)

  const sealsList = (logos) => {
    return filterSeals(logos).sort( (a,b) => parseInt(a.position) - parseInt(b.position)).map( (s, index) => <img key={s.id} style={{height: "50px", paddingRight: "20px"}} alt='' src={URLS['BACKEND'] + '/' + s.image_url} /> );
  }

  useEffect(() => {
      const fetchData = async () => {
        const result = await axiosPublic(
          actionUrl,
        );
        setLogos(result.data.frontend_seal_elements);
      };
      fetchData();
    }, []);

  return (
  <Aux>
    <div className="row justify-content-center">
      <div className="col-xl-9 col-lg-9 col-md-9">
        <div className="text-center" style={{paddingTop: "20px"}}>
          <span className="text-justify">{sealsList(logos)}</span>
        </div>
      </div>
    </div>
  </Aux>
  )
};

export default Logobar;



// WEBPACK FOOTER //
// ./src/components/Shared/Logobar.js